import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './firebase';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
// import reportWebVitals from './reportWebVitals';
import { createBrowserHistory } from "history";
import store from "./store";
import { Provider } from "react-redux";
import { HashRouter } from 'react-router-dom'
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { FirebaseProvider } from './FirebaseContext';
import SpecProvider from './component/auction/SpecContext';

store.subscribe(() => store.getState);

const history = createBrowserHistory();


ReactDOM.render(
  <BrowserRouter basename={'/user'} >
    <React.StrictMode>
      <DndProvider backend={HTML5Backend}>
<SpecProvider>
        <Provider store={store}>
          <FirebaseProvider>

            <App />
          </FirebaseProvider>

        </Provider>
        </SpecProvider>
      </DndProvider>

    </React.StrictMode>
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

